/* Hashtag Glow-up — revelation au scroll + localisation 404 (defensif) */
(function(){
  var d=document, root=d.documentElement;

  function localize404(){
    try{
      var main=d.getElementById('MainContent');
      if(!main) return;
      var tpl=(main.getAttribute('data-template')||'');
      if(tpl.indexOf('404')!==0) return;
      var map=[
        ['Page not found','Page introuvable'],
        ['The link may be incorrect, or the page has been removed.','Le lien est peut-être incorrect, ou la page a été supprimée.'],
        ['Continue shopping','Continuer mes achats'],
        ['Discover something new','Découvrez nos nouveautés'],
        ['SHOP ALL','Voir tout'],
        ['Shop all','Voir tout']
      ];
      var walker=d.createTreeWalker(main, NodeFilter.SHOW_TEXT, null);
      var nodes=[]; while(walker.nextNode()){ nodes.push(walker.currentNode); }
      nodes.forEach(function(n){
        var v=(n.nodeValue||'').trim();
        for(var i=0;i<map.length;i++){ if(v===map[i][0]){ n.nodeValue=n.nodeValue.replace(map[i][0], map[i][1]); break; } }
      });
    }catch(e){}
  }

  function reveal_init(){
    try{
      var main=d.getElementById('MainContent')||d.body;
      var secs=[].slice.call(main.querySelectorAll('.section'));
      var targets=[];
      secs.forEach(function(s,i){
        if(i===0) return;
        if(s.closest('.htg-reveal')) return;
        var r=s.getBoundingClientRect();
        if(r.top < (window.innerHeight*0.9)) return;
        s.classList.add('htg-reveal');
        targets.push(s);
      });
      if(!targets.length) return;
      root.classList.add('htg-anim');
      var reveal=function(t){ t.classList.add('htg-in'); };
      if(!('IntersectionObserver' in window)){ targets.forEach(reveal); return; }
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ reveal(e.target); io.unobserve(e.target); } });
      }, { threshold:0.06, rootMargin:'0px 0px -6% 0px' });
      targets.forEach(function(t){ io.observe(t); });
      setTimeout(function(){ targets.forEach(reveal); }, 2600);
    }catch(e){ root.classList.remove('htg-anim'); }
  }

  function init(){ localize404(); reveal_init(); }
  if(d.readyState!=='loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
